import React from 'react';
import GrantOnboardingAccess from '../Onboarding/GrantOnboardingAccess/GrantOnboardingAccess';
import styles from './GrantAccess.module.css';

// Standalone page for connecting data-source platforms to the active
// project. Previously "step 2" of the Onboarding stepper — now its own
// route (/grant-access), reached after project creation or by switching
// to a project that has zero connected platforms. "Finish anyway" (inside
// GrantOnboardingAccess) navigates to /analyze/insights -- the
// select-dashboards screen is now redundant in this flow since all
// dashboards are enabled by default, though the screen itself still exists
// for AllDashboards.jsx's own (currently hidden) "Add from Templates" flow.
const GrantAccess = ({ currentProject }) => {
  return (
    <div className={styles.pageShell}>
      <GrantOnboardingAccess project={currentProject} />
    </div>
  );
};

export default GrantAccess;
